import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { downloadFile } from '@wb/shared/utils/files';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClientListReport } from '@wb/core/schema/query-definitions/system.graphql';
import dayjs from 'dayjs';

@Component({
  selector: 'app-date-range-selector',
  templateUrl: './client-report-dialog.component.html',
  styleUrls: ['./client-report-dialog.component.sass'],
})
export class ClientReportDialogComponent implements OnDestroy {
  @Output() save: EventEmitter<void> = new EventEmitter();

  formGroup: FormGroup = new FormGroup({
    startDate: new FormControl(null),
    endDate: new FormControl(null),
    range: new FormControl('currentMonth'),
  });

  isLoadingData = true;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { accountUid: string; isAggregator: boolean },
    public dialogRef: MatDialogRef<ClientReportDialogComponent>,
    public readonly clientListReportGQL: ClientListReport,
  ) {
    this.isLoadingData = false;
    this.formGroup.patchValue({
      startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  async onSubmit() {
    let startDate = this.formGroup.value.startDate;
    let endDate = this.formGroup.value.endDate;

    if (this.formGroup.value.range !== 'static') {
      switch (this.formGroup.value.range) {
        case 'lastMonth':
          startDate = dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          endDate = dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
        case 'last3Months':
          startDate = dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD');
          endDate = dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
        default:
          startDate = dayjs().startOf('month').format('YYYY-MM-DD');
          endDate = dayjs().format('YYYY-MM-DD');
      }

      this.formGroup.patchValue({ startDate, endDate });
    }

    this.clientListReportGQL
      .fetch(
        {
          accountUids: JSON.stringify([this.data.accountUid]),
          startDate,
          endDate,
          isAggregator: this.data.isAggregator,
        },
        { fetchPolicy: 'network-only' },
      )
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        try {
          const clientReport = JSON.parse(response.data.clientReport.clientReport);
          downloadFile(clientReport, 'WebBuy Client List.csv');
          this.dialogRef.close(true);
        } catch (error) {
          console.error(error);
        }
      });
  }
}
